// intent_glyph.ts — wire-shape AxisV → display glyph utility.
//
// Source of truth: docs/contracts/m0/meeting_intent_model.md v0.2
// FE spec:        docs/frontend_eng_spec/m0_5/i18n_glyph.md §1
//
// Glyphs are output-only — never used as map keys, store values, or wire
// payloads. The canonical AxisV strings (`converge`, `diverge`, ...)
// flow through api/store/transit; glyphs are rendered only at the UI
// edge by this module.

import type { AxisV } from '@/types/intent';

// Canonical AxisV → display glyph map. NEVER inverted.
export const INTENT_GLYPHS: Record<AxisV, string> = {
  converge: '∇',
  diverge: '△',
  validate: '?',
  diagnose: '!',
  resolve: '⇌',
  project: '→',
};

/** Returns the display glyph for V, or '' for legacy sessions / undefined. */
export function intentGlyph(v: AxisV | null | undefined): string {
  if (!v) return '';
  return INTENT_GLYPHS[v] ?? '';
}

/** i18n key for a preset's label (matches keys in zh.json / en.json). */
export function intentLabelKey(v: AxisV): string {
  return `intent.preset.${v}.label`;
}
